<template>
    <div style="display: flex; flex-direction: column; margin: 20px;">
      <v-data-table
        :headers="headers"
        :items="items"
        style="width: 100%;"
        :footer-props="{
                    'items-per-page-options': [20, 50, 100, -1],
                    'items-per-page-text': this.$t('_lignes_par_page_'),           
                  }"
        class="custom-data-table"
      >
      </v-data-table>
      <v-btn style="width: 300px;">{{ $t("_telecharger_le_tableau_comparatif_") }}</v-btn>
    </div>
  </template>
  
  <script>

  export default {
    props: {
      liste_alarmes: {
        type: Array,
        required: true
      }
    },

    data() {
      return {
        headers: [
          { text: 'Catégorie', value: 'categorie' },
          { text: 'Site', value: 'site' },
          { text: 'Type d\'incident', value: 'type_incident' },
          { text: 'Criticité', value: 'criticite' },
          { text: 'PC', value: 'pc' },
          { text: 'Commune', value: 'commune' },
          { text: 'Pertes (énergie) / (monnaie)', value: 'pertes' },
          { text: 'Dates', value: 'dates' },
        ],
        items: [
          {
            categorie: 'Électricité',
            site: 'Site A',
            type_incident: 'Coupure',
            criticite: 'Élevée',
            pc: 'PC1',
            commune: 'Commune 1',
            pertes: '100 kWh / 50 €',
            dates: '01/01/2024',
          },
          {
            categorie: 'Eau',
            site: 'Site B',
            type_incident: 'Fuite',
            criticite: 'Moyenne',
            pc: 'PC2',
            commune: 'Commune 2',
            pertes: '200 L / 30 €',
            dates: '02/01/2024',
          },
        ],
      };
    },
  };
  </script>
  
  <style>
  .custom-data-table {
    border-radius: 10px;
    overflow: hidden;
  }
  
  .custom-data-table .v-data-table-header {
    background-color: #e0e0e0;
  }
  
  .custom-data-table .v-data-table-header th {
    background-color: #e0e0e0;
  }
  </style>
  